import { markdownToHtml } from "./markdownDomain";
import { classNames } from "../utils/classNames";

export function Markdown({
  value,
  disableLastMargin,
  preview,
  truncate,
  inheritLinkColor,
}: {
  value: string;
  disableLastMargin?: boolean;
  preview?: boolean;
  truncate?: boolean;
  inheritLinkColor?: boolean;
}) {
  return (
    <div
      className={classNames(
        preview ? "preview-content" : "content",
        disableLastMargin && "disable-last-margin",
        truncate && "tw-truncate",
        inheritLinkColor && "text-inherit",
      )}
    >
      {truncate ? markdownToHtml(value.split("\n")[0]) : markdownToHtml(value)}
    </div>
  );
}
